<script>
// 안내 글의 [메뉴 이름]·'단추 이름'(일본어는 「단추 이름」)은 줄 끝에서 둘로 갈라지지 않게 한 덩어리로 넘긴다. 글자는 그대로다.
// '[가] > [나]'처럼 이어진 길은 통째로 한 덩어리로 넘겨 길이 두 줄로 끊겨 보이지 않게 한다.
// chip을 주면 이름마다 작은 이름표 칸으로 보여 찾아갈 곳이 먼저 눈에 띄게 한다(누르는 단추처럼 보이지 않게 모서리는 작게)
const PATH = /(\[[^\]\n]+\](?:\s*>\s*\[[^\]\n]+\])+)/
const NAME = /(\[[^\]\n]+\]|'[^'\n]+'|「[^」\n]+」)/
const CHIP = { whiteSpace: "nowrap", margin: "0 2px", padding: "1px 6px", borderRadius: "6px", background: "#fdf0f0", color: "#b9345d", fontWeight: "600" }
const KEEP = { whiteSpace: "nowrap" }
// 이름표 바로 뒤에 문장부호가 붙으면 이름표 오른쪽 여백을 없애 부호가 떠 보이지 않게 한다('[예약 내역] .'처럼 보임, 10/17)
const PUNCT = /^[.,。、]/

function names(h, text, chip, punctAfter) {
  const parts = text.split(NAME).filter((part) => part !== "")
  return parts.map((part, i) => {
    if (!NAME.test(part)) return part
    const next = i + 1 < parts.length ? PUNCT.test(parts[i + 1]) : punctAfter
    return h("span", { style: chip ? (next ? { ...CHIP, marginRight: 0 } : CHIP) : KEEP }, part)
  })
}

export default {
  name: "KeepTogether",
  functional: true,
  props: { text: { type: String, default: "" }, chip: { type: Boolean, default: false } },
  render(h, { props }) {
    const parts = props.text.split(PATH).filter((part) => part !== "")
    return parts.reduce((out, part, i) => {
      const punctAfter = i + 1 < parts.length && PUNCT.test(parts[i + 1])
      return out.concat(PATH.test(part) ? [h("span", { style: KEEP }, names(h, part, props.chip, punctAfter))] : names(h, part, props.chip, punctAfter))
    }, [])
  },
}
</script>
